const CHARSET = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";

export function generateCouponCode(prefix = "SUSHI"): string {
  let suffix = "";
  for (let i = 0; i < 6; i += 1) {
    suffix += CHARSET[Math.floor(Math.random() * CHARSET.length)];
  }
  return `${prefix}${suffix}`;
}
